var map = {
	"./abstrato-1-thumb.jpg": 292,
	"./abstrato-1.jpg": 975,
	"./abstrato-2-thumb.jpg": 293,
	"./abstrato-2.jpg": 976,
	"./abstrato-3-thumb.jpg": 294,
	"./abstrato-3.jpg": 977,
	"./abstrato-4-thumb.jpg": 295,
	"./abstrato-4.jpg": 978,
	"./abstrato-5-thumb.jpg": 296,
	"./abstrato-5.jpg": 979,
	"./abstrato-6-thumb.jpg": 297,
	"./abstrato-6.jpg": 980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 974;